"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _menu = require("../utils/menu");
var _requester2 = _interopRequireDefault(require("./requester"));
var _constant = require("../constant");
var _lodash = require("lodash");
var _common = require("../utils/common");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable no-underscore-dangle */
/**
 * 数据管理的删除扩展类
 */
var DeleteRequester = /*#__PURE__*/function (_requester) {
  (0, _inherits2.default)(DeleteRequester, _requester);
  var _super = _createSuper(DeleteRequester);
  function DeleteRequester() {
    (0, _classCallCheck2.default)(this, DeleteRequester);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(DeleteRequester, [{
    key: "deleteAllDataDetail",
    value:
    /**
     * 删除多条主表数据的table树数据
     * @param {*} oldData
     */
    function () {
      var _deleteAllDataDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(oldList) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 基于旧数据，得到一颗还原后包含数据的table树
              this.regainTableTreeByDataTree(oldList, this.tableTree);
              // 对table树中不再引用的数据，优先递归解绑关联键值
              this.setNotDependDataByTable(this.tableTree);
              _context.next = 4;
              return this.saveDataForEdit();
            case 4:
              _context.next = 6;
              return this.saveDataForDelete();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function deleteAllDataDetail(_x) {
        return _deleteAllDataDetail.apply(this, arguments);
      }
      return deleteAllDataDetail;
    }() // ---------------------------------------------
    /**
     * 对table树中不再引用的数据编辑删除 or 解除关联
     * @param {*} table table实例
     * @param {*} parentRelationObj 当前table与父节点的关系
     * @param {*} parentTable 父table实例
     */
  }, {
    key: "setNotDependDataByTable",
    value: function setNotDependDataByTable(table, parentRelationObj, parentTable) {
      var _this = this;
      var tableExtendInfo = table.tableExtendInfo;
      var dataList = table.dataList.filter(function (data) {
        return !data.__isDepend;
      });
      // 非根节点的才判断是否解除关联
      if (parentRelationObj && parentTable) {
        var _parentRelationObj$re = (0, _slicedToArray2.default)(parentRelationObj.relation, 3),
          relation0 = _parentRelationObj$re[0],
          relation1 = _parentRelationObj$re[1],
          relation2 = _parentRelationObj$re[2];
        dataList.forEach(function ($data) {
          var data = $data;
          var rightFieldData = _this.getFieldData(data, relation2);
          if ((0, _common.noneValue)(rightFieldData)) {
            return;
          }

          // 普通关联的键在子表、父表
          if (relation1 === _menu.RelationStatus.RIGHT || relation1 === _menu.RelationStatus.LEFT) {
            // 若父数据存在未引用的但又不删除，此数据不动（父节点允许配置成仅解除关联）
            var result = parentTable.dataList.find(function (parentData) {
              var leftFieldData = _this.getFieldData(parentData, relation0);
              return !parentData.__isDepend && parentData.__changeType !== _menu.DataStatus.DELETE && leftFieldData === rightFieldData;
            });
            if (!result && tableExtendInfo.deleteType !== 3) {
              // 声明不保留的，标记要删除
              data.__changeType = _menu.DataStatus.DELETE;
            }
          }

          // link关联的键值在子表：当前的子表即data
          if (relation1 === _menu.RelationStatus.IN) {
            // 解除父数据中已要删除数据的关联
            var linkValues = "".concat(rightFieldData).split(_constant.LINKSPLIT);
            parentTable.dataList.forEach(function (parentData) {
              var leftFieldData = _this.getFieldData(parentData, relation0);
              ;
              // 过滤掉要删除的父数据的关联键引用
              if (!parentData.__isDepend && parentData.__changeType === _menu.DataStatus.DELETE) {
                linkValues = linkValues.filter(function (link) {
                  return link !== "".concat(leftFieldData);
                });
              }
            });
            var linkValuesStr = linkValues.join(_constant.LINKSPLIT);
            if (!linkValuesStr && tableExtendInfo.deleteType !== 3) {
              // 如若关联都被清空了 + 声明不保留，则标记要删除
              data.__changeType = _menu.DataStatus.DELETE;
            } else if ("".concat(rightFieldData) !== linkValuesStr) {
              // 说明关联link的值有改变
              _this.setFieldData(data, relation2, linkValuesStr);
            }
          }

          // link关联的键在父表
          if (relation1 === _menu.RelationStatus.INCLUDE) {
            // 若父数据存在未引用的但又不删除，此数据不动
            var _result = parentTable.dataList.find(function (parentData) {
              var leftFieldData = _this.getFieldData(parentData, relation0);
              ;
              return !parentData.__isDepend && parentData.__changeType !== _menu.DataStatus.DELETE && leftFieldData && "".concat(leftFieldData).split(_constant.LINKSPLIT).indexOf("".concat(rightFieldData)) > -1;
            });
            if (!_result && tableExtendInfo.deleteType !== 3) {
              // 声明不保留的，标记要删除
              data.__changeType = _menu.DataStatus.DELETE;
            }
          }
          ;
        });
      } else {
        dataList.forEach(function ($data) {
          var data = $data;
          data.__changeType = _menu.DataStatus.DELETE;
        });
      }
      if (table.forkTableList.length > 0) {
        table.forkTableList.forEach(function (forkTableObj) {
          var relationObj = forkTableObj.relationObj,
            forkTable = forkTableObj.forkTable;
          _this.setNotDependDataByTable(forkTable, relationObj, table);
        });
      }
    }

    // ---------------------------------------------
    /**
     * 所table树中有引用、要编辑的数据，递归保存到无极api
     */
  }, {
    key: "saveDataForEdit",
    value: function () {
      var _saveDataForEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this2 = this;
        var allPromise;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              allPromise = [];
              this.rawTableList.forEach(function (table) {
                var dataList = table.dataList,
                  primaryKey = table.primaryKey,
                  rawPrimaryKey = table.rawPrimaryKey,
                  dataApi = table.dataApi;
                dataList.forEach(function ($data) {
                  var data = $data;
                  if (data.__changeType === _menu.DataStatus.EDIT) {
                    var cloneData = (0, _lodash.cloneDeep)(data.__changeFields || {});
                    if (Object.keys(cloneData).length > 0) {
                      cloneData[primaryKey] = data[primaryKey];
                      allPromise.push(dataApi.update(cloneData, {
                        uuid: _this2.uuid,
                        errMsg: _this2.errMsg
                      }, (0, _common.cloneRawData)(data)).then(function (bl) {
                        // 如果编辑时出现修改主键(自定义主键)，则回填原数据(用于可能的返回给用户)
                        var updatePrimaryKeyValue = (0, _common.getValueByPath)(cloneData, rawPrimaryKey);
                        if (bl && updatePrimaryKeyValue) {
                          (0, _common.setValueByPath)(data, rawPrimaryKey, updatePrimaryKeyValue);
                          data[primaryKey] = updatePrimaryKeyValue;
                        }
                      }));
                    }
                  }
                });
              });
              _context2.next = 4;
              return (0, _common.allSettled)(allPromise);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveDataForEdit() {
        return _saveDataForEdit.apply(this, arguments);
      }
      return saveDataForEdit;
    }() // ---------------------------------------------
    /**
     * 对table树的处理后不再关联数据的处理
     */
  }, {
    key: "saveDataForDelete",
    value: function () {
      var _saveDataForDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this3 = this;
        var allPromise;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              allPromise = [];
              this.rawTableList.forEach(function (table) {
                var dataList = table.dataList,
                  primaryKey = table.primaryKey,
                  dataApi = table.dataApi,
                  _table$tableExtendInf = table.tableExtendInfo,
                  deleteType = _table$tableExtendInf.deleteType,
                  deleteField = _table$tableExtendInf.deleteField,
                  deleteValue = _table$tableExtendInf.deleteValue;
                dataList.forEach(function (data) {
                  if (data.__changeType === _menu.DataStatus.DELETE) {
                    if (deleteType === 1) {
                      allPromise.push(dataApi.delete({
                        id: data[primaryKey]
                      }, {
                        uuid: _this3.uuid,
                        errMsg: _this3.errMsg
                      }));
                    } else {
                      // 有可能是深度keypath，要预先提取首层key值
                      var _deleteField$split = deleteField.split('.'),
                        _deleteField$split2 = (0, _slicedToArray2.default)(_deleteField$split, 1),
                        firstKey = _deleteField$split2[0];
                      var editData = {};
                      editData[primaryKey] = data[primaryKey];
                      editData[firstKey] = data[firstKey];
                      (0, _common.setValueByPath)(editData, deleteField, deleteValue);
                      allPromise.push(dataApi.update(editData, {
                        uuid: _this3.uuid,
                        errMsg: _this3.errMsg
                      }), (0, _common.cloneRawData)(data));
                    }
                  }
                });
              });
              _context3.next = 4;
              return (0, _common.allSettled)(allPromise);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function saveDataForDelete() {
        return _saveDataForDelete.apply(this, arguments);
      }
      return saveDataForDelete;
    }()
    /**
     * 设置数据的编辑状态
     * @param {*} $data
     * @param {*} changeObj
     */
  }, {
    key: "setEditState",
    value: function setEditState($data, changeObj) {
      var data = $data;
      data.__changeType = _menu.DataStatus.EDIT;
      data.__changeFields = _objectSpread(_objectSpread({}, data.__changeFields || {}), changeObj);
    }

    /**
     * 获取关联字段值
     * @param {*} data
     * @param {*} relationKey
     * @returns
     */
  }, {
    key: "getFieldData",
    value: function getFieldData(data, relationKey) {
      var _relationKey$split = relationKey.split('.'),
        _relationKey$split2 = (0, _slicedToArray2.default)(_relationKey$split, 1),
        firstKey = _relationKey$split2[0];
      // 有可能是深度的keyPath，先判断根key已被修改收集了
      if (data.__changeFields && data.__changeFields[firstKey] !== undefined) {
        return (0, _common.getValueByPath)(data.__changeFields, relationKey);
      }
      return (0, _common.getValueByPath)(data, relationKey);
    }
  }, {
    key: "setFieldData",
    value: function setFieldData(data, relationKey, value) {
      // 先设置为编辑态
      this.setEditState(data, {});
      var _relationKey$split3 = relationKey.split('.'),
        _relationKey$split4 = (0, _slicedToArray2.default)(_relationKey$split3, 1),
        firstKey = _relationKey$split4[0];
      // 有可能是深度的keyPath，未收集的先复制
      if (data.__changeFields[firstKey] === undefined) {
        // eslint-disable-next-line
        data.__changeFields[firstKey] = (0, _lodash.cloneDeep)(data[firstKey]);
      }
      (0, _common.setValueByPath)(data.__changeFields, relationKey, value);
    }
  }]);
  return DeleteRequester;
}(_requester2.default);
var _default = DeleteRequester;
exports.default = _default;